module.exports = {"title":"oops","body":"<h1>NOT FOUND</h1>\n<p>You just hit a route that doesn’t exist… the sadness.</p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./404.md
 ** module id = 436
 ** module chunks = 0
 **/